import React, { useState, useContext, useEffect } from 'react';
import { Button, Modal, Form, Input, Row, Col, Select, Spin, Divider, Switch, InputNumber, Space } from 'antd';
import utils from '../../../utils';
import http from '../../../Http';
import { useTranslation } from 'react-i18next';

let timeout;
let currentSearchValue;
const fetch = (value, callback) => {
    if (timeout) {
        clearTimeout(timeout);
        timeout = null;
    }
    currentSearchValue = value;

    const fake = () => {
        http.post("inverter-v2/inverters-sns-mark-with-agile-price/get", {
            SN: value,
        }).then(async (r)=>{
            return await r.json();
        }).then((r) => {
            if (currentSearchValue === value) {
                const {data} = r;
                if (data) {
                    const opts = data.map((item) => ({
                        value: item["SN"],
                        label: item["SN"],
                        disabled: item["WithAgilePrice"] == 1,
                    }))
                    callback (opts, null)
                } else {
                    callback (null, "")
                }
            }
        }).catch((e)=>{
            callback(null, "failed to load data")
            return null;
        });
    };
    timeout = setTimeout(fake, 300);
}

const timeOpts = [
    {value: (0*100)+0, label: "00:00"},
    {value: (0*100)+30, label: "00:30"},
    {value: (1*100)+0, label: "01:00"},
    {value: (1*100)+30, label: "01:30"},
    {value: (2*100)+0, label: "02:00"},
    {value: (2*100)+30, label: "02:30"},
    {value: (3*100)+0, label: "03:00"},
    {value: (3*100)+30, label: "03:30"},
    {value: (4*100)+0, label: "04:00"},
    {value: (4*100)+30, label: "04:30"},
    {value: (5*100)+0, label: "05:00"},
    {value: (5*100)+30, label: "05:30"},
    {value: (6*100)+0, label: "06:00"},
    {value: (6*100)+30, label: "06:30"},
    {value: (7*100)+0, label: "07:00"},
    {value: (7*100)+30, label: "07:30"},
    {value: (8*100)+0, label: "08:00"},
    {value: (8*100)+30, label: "08:30"},
    {value: (9*100)+0, label: "09:00"},
    {value: (9*100)+30, label: "09:30"},
    {value: (10*100)+0, label: "10:00"},
    {value: (10*100)+30, label: "10:30"},
    {value: (11*100)+0, label: "11:00"},
    {value: (11*100)+30, label: "11:30"},
    {value: (12*100)+0, label: "12:00"},
    {value: (12*100)+30, label: "12:30"},
    {value: (13*100)+0, label: "13:00"},
    {value: (13*100)+30, label: "13:30"},
    {value: (14*100)+0, label: "14:00"},
    {value: (14*100)+30, label: "14:30"},
    {value: (15*100)+0, label: "15:00"},
    {value: (15*100)+30, label: "15:30"},
    {value: (16*100)+0, label: "16:00"},
    {value: (16*100)+30, label: "16:30"},
    {value: (17*100)+0, label: "17:00"},
    {value: (17*100)+30, label: "17:30"},
    {value: (18*100)+0, label: "18:00"},
    {value: (18*100)+30, label: "18:30"},
    {value: (19*100)+0, label: "19:00"},
    {value: (19*100)+30, label: "19:30"},
    {value: (20*100)+0, label: "20:00"},
    {value: (20*100)+30, label: "20:30"},
    {value: (21*100)+0, label: "21:00"},
    {value: (21*100)+30, label: "21:30"},
    {value: (22*100)+0, label: "22:00"},
    {value: (22*100)+30, label: "22:30"},
    {value: (23*100)+0, label: "23:00"},
    {value: (23*100)+30, label: "23:30"},
]


const pointOpts = [
    {value: 1, label: "1"},
    {value: 2, label: "2"},
    {value: 3, label: "3"},
    {value: 4, label: "4"},
    {value: 5, label: "5"},
    {value: 6, label: "6"},
    {value: 7, label: "7"},
    {value: 8, label: "8"},
    {value: 9, label: "9"},
    {value: 10, label: "10"},
    {value: 11, label: "11"},
    {value: 12, label: "12"},
]

function InverterWithAgilePriceAddOrModify({open, onOk, onCancel, info}) {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [inverterSNopts, setInverterSNopts] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [weekEndException, setWeekEndException] = useState(false);
    const [pointOrPriceWeekDay, setPointOrPriceWeekDay] = useState("POINTS");
    const [pointOrPriceWeekEnd, setPointOrPriceWeekEnd] = useState("POINTS");
    const [importOctopusProductCodeOpts, setImportOctopusProductCodeOpts] = useState([]);
    const [exportOctopusProductCodeOpts, setExportOctopusProductCodeOpts] = useState([]);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const setTip = useContext(utils.tipContext);

    const tip = "[InverterWithAgilePriceAddOrModify]";


    useEffect(()=>{
        let x = {...info};
        if (info.isNew) {
            x.InverterSN = x.InverterSN??"";
            x.PostCode = x.PostCode??"";
            x.ChargeWhenNegative = x.ChargeWhenNegative??1;
            x.PointOrPriceWeekDay = x.PointOrPriceWeekDay?? "POINTS";
            x.PointOrPriceWeekEnd = x.PointOrPriceWeekEnd?? "POINTS";
            // weekday
            x.STimeOfCharging1WeekDay = x.STimeOfCharging1WeekDay?? (0*100)+0;
            x.ETimeOfCharging1WeekDay = x.ETimeOfCharging1WeekDay?? (6*100)+0;
            x.PointNumberOfCharging1WeekDay = x.PointNumberOfCharging1WeekDay?? 4;
            // x.PriceOfCharging1WeekDay = x.PriceOfCharging1WeekDay?? 0;
            x.STimeOfDischarging1WeekDay = x.STimeOfDischarging1WeekDay?? (8*100)+0;
            x.ETimeOfDischarging1WeekDay = x.ETimeOfDischarging1WeekDay?? (12*100)+0;
            x.PointNumberOfDischarging1WeekDay = x.PointNumberOfDischarging1WeekDay?? 0;
            // x.PriceOfDischarging1WeekDay = x.PriceOfDischarging1WeekDay?? 0;
            
            x.STimeOfCharging2WeekDay = x.STimeOfCharging2WeekDay?? (14*100)+0;
            x.ETimeOfCharging2WeekDay = x.ETimeOfCharging2WeekDay?? (17*100)+0;
            x.PointNumberOfCharging2WeekDay = x.PointNumberOfCharging2WeekDay?? 2;
            // x.PriceOfCharging2WeekDay = x.PriceOfCharging2WeekDay?? 0;
            x.STimeOfDischarging2WeekDay = x.STimeOfDischarging2WeekDay?? (19*100)+0;
            x.ETimeOfDischarging2WeekDay = x.ETimeOfDischarging2WeekDay?? (23*100)+30;
            x.PointNumberOfDischarging2WeekDay = x.PointNumberOfDischarging2WeekDay?? 0;
            // x.PriceOfDischarging2WeekDay = x.PriceOfDischarging2WeekDay?? 0;
            // weekend
            x.STimeOfCharging1WeekEnd = x.STimeOfCharging1WeekEnd?? (0*100)+0;
            x.ETimeOfCharging1WeekEnd = x.ETimeOfCharging1WeekEnd?? (6*100)+0;
            x.PointNumberOfCharging1WeekEnd = x.PointNumberOfCharging1WeekEnd?? 4;
            // x.PriceOfCharging1WeekEnd = x.PriceOfCharging1WeekEnd?? 0;
            x.STimeOfDischarging1WeekEnd = x.STimeOfDischarging1WeekEnd?? (8*100)+0;
            x.ETimeOfDischarging1WeekEnd = x.ETimeOfDischarging1WeekEnd?? (12*100)+0;
            x.PointNumberOfDischarging1WeekEnd = x.PointNumberOfDischarging1WeekEnd?? 0;
            // x.PriceOfDischarging1WeekEnd = x.PriceOfDischarging1WeekEnd?? 0;
            
            x.STimeOfCharging2WeekEnd = x.STimeOfCharging2WeekEnd?? (14*100)+0;
            x.ETimeOfCharging2WeekEnd = x.ETimeOfCharging2WeekEnd?? (17*100)+0;
            x.PointNumberOfCharging2WeekEnd = x.PointNumberOfCharging2WeekEnd?? 2;
            // x.PriceOfCharging2WeekEnd = x.PriceOfCharging2WeekEnd?? 0;
            x.STimeOfDischarging2WeekEnd = x.STimeOfDischarging2WeekEnd?? (19*100)+0;
            x.ETimeOfDischarging2WeekEnd = x.ETimeOfDischarging2WeekEnd?? (23*100)+30;
            x.PointNumberOfDischarging2WeekEnd = x.PointNumberOfDischarging2WeekEnd?? 0;
            // x.PriceOfDischarging2WeekEnd = x.PriceOfDischarging2WeekEnd?? 0;
        }

        x.WeekEndException = x.WeekEndException == 1 ? true:false;

        setWeekEndException(x.WeekEndException);
        setPointOrPriceWeekDay(x.PointOrPriceWeekDay);
        setPointOrPriceWeekEnd(x.PointOrPriceWeekEnd);

        form.setFieldsValue(x);
    }, [info])

    useEffect(()=>{
        // import
        http.post("inverter-v2/octopus-product-codes/get", {Direction: "IMPORT"}).then(async (r) => {
            return await r.json();
        }).then((resp) => {
            if (resp.code !== 200) {
                setTip({open: true, severity: 'error', msg: t("get octopus product code error")});
                return;
            }

            setImportOctopusProductCodeOpts(resp.data.map((item)=>({value: item.Code, label: item.Name})));
            if (resp.data.length == 1) {
                form.setFieldsValue({ImportOctopusProductCode: resp.data[0].Code});
            }
        }).catch((e) => {
            console.log(tip, e);
            setTip({open: true, severity: 'error', msg: t("get octopus product code error")});
        });

        // export
        http.post("inverter-v2/octopus-product-codes/get", {Direction: "EXPORT"}).then(async (r) => {
            return await r.json();
        }).then((resp) => {
            if (resp.code !== 200) {
                setTip({open: true, severity: 'error', msg: t("get octopus product code error")});
                return;
            }

            setExportOctopusProductCodeOpts(resp.data.map((item)=>({value: item.Code, label: item.Name})));
            if (resp.data.length == 1) {
                form.setFieldsValue({ExportOctopusProductCode: resp.data[0].Code});
            }
        }).catch((e) => {
            console.log(tip, e);
            setTip({open: true, severity: 'error', msg: t("get octopus product code error")});
        });
    }, [])


    
    const handleSearch = (value) => {
        if (value) {
            setFetching(true);
            fetch(value, (opts, err) => {
                setFetching(false);
                if (err) {
                    setTip({ open: true, severity: "error", msg: err });
                }
                setInverterSNopts(opts);
            })
        }
    }

    const handleOk = () => {
        setConfirmLoading(true);
        form.validateFields().then((values)=>{
            console.log(values);

            if (info.isNew) {
                values.isNew = true;
            }

            values.WeekEndException = values.WeekEndException ? 1:0;

            onOk(values);
        }).finally(()=>{
            setConfirmLoading(false);
        })
    }

    return <Modal 
        title={info&&info.isNew ? t("Add Inverter Alige-Price") : t("Edit Inverter Alige-Price")} 
        visible={open} 
        onOk={handleOk} 
        confirmLoading={confirmLoading}
        onCancel={onCancel}
        width={"70%"}
        style={{maxWidth: 1200}}
    >
        <Form
            form={form}
            labelCol={{span: 12}}            
            style={{paddingRight: 20}}
            initialValues={info}
        >
            <Row>
                <Col span={12}>
                    <Form.Item required={true} label={t("Inverter SN")} name="InverterSN" rules={[{required: true, message: t('Please input Inverter SN')}]}>
                        {!info.isNew?<Input disabled={true}/>
                        :<Select
                            showSearch={true}
                            showArrow={true}
                            placeholder={t("Please Enter Inverter SN and Select")}
                            options={inverterSNopts}
                            onSearch={handleSearch}
                            notFoundContent={fetching ? <Spin size="small" /> : null}
                        />}
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item required={true} label={t("Charge When Negative Price")} name="ChargeWhenNegative" rules={[{required: true}]}>
                        <Select options={[{value: 1, label: t("Yes")}, {value: 0, label: t("No")}]}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item required={true} label={t("Postcode")} name="PostCode" rules={[{required: true, type: "string", min: 3, max: 10, whitespace: true}]}>
                        <Input />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item required={true} label={t("Product Code for Import")} name="ImportOctopusProductCode" rules={[{required: true}]}>
                        <Select options={importOctopusProductCodeOpts} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item required={true} label={t("Product Code for Export")} name="ExportOctopusProductCode" rules={[{required: true}]}>
                        <Select options={exportOctopusProductCodeOpts} />
                    </Form.Item>
                </Col>
            </Row>
            <Divider />
            <Row>
                <Col offset={12} span={12}>
                    <Form.Item label={t("Weekend Exception")} name="WeekEndException" valuePropName="checked">
                        <Switch onChange={(v)=>setWeekEndException(v)}/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item required={true} label={t("Point Or Price for Weekday")} name="PointOrPriceWeekDay" rules={[{required: true}]}>
                        <Select onChange={(v)=>setPointOrPriceWeekDay(v)} options={[{value: "POINTS", label: t("POINTS")}, {value: "PRICE", label: t("Price")}]}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item hidden={!weekEndException} required={weekEndException} label={t("Point Or Price for Weekend")} name="PointOrPriceWeekEnd" rules={[{required: weekEndException}]}>
                        <Select  onChange={(v)=>setPointOrPriceWeekEnd(v)} options={[{value: "POINTS", label: t("POINTS")}, {value: "PRICE", label: t("Price")}]}/>
                    </Form.Item>
                </Col>
            </Row>
            {/* 1 */}
            <Row>
                <Col span={12} style={{fontWeight: "bold", textAlign: "center", paddingBottom: 10}}>{t("Weekdays Time Setting 1")}</Col>
                <Col hidden={!weekEndException} span={12} style={{fontWeight: "bold", textAlign: "center", paddingBottom: 10}}>{t("Weekends Time Setting 1")}</Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item label={t("Charge Time Range 1")} rules={[{required: true}]} style={{ marginBottom: 0 }} >
                        <Space>
                            <Form.Item required={true} name="STimeOfCharging1WeekDay" rules={[{required: true, message: t("required")}]}>
                                <Select style={{width: 90}} options={timeOpts}/>
                            </Form.Item>
                            <Form.Item>-</Form.Item>
                            <Form.Item required={true} name="ETimeOfCharging1WeekDay" rules={[{required: true, message: t("required")}]}>
                                <Select style={{width: 90}} options={timeOpts}/>
                            </Form.Item>
                        </Space>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item  hidden={!weekEndException} label={t("Charge Time Range 1")}  style={{ marginBottom: 0 }}>
                        <Space>
                            <Form.Item required={weekEndException} name="STimeOfCharging1WeekEnd" rules={[{required: weekEndException, message: t("required")}]}>
                                <Select style={{width: 90}} options={timeOpts}/>
                            </Form.Item>
                            <Form.Item>-</Form.Item>
                            <Form.Item required={weekEndException} name="ETimeOfCharging1WeekEnd" rules={[{required: weekEndException, message: t("required")}]}>
                                <Select style={{width: 90}} options={timeOpts}/>
                            </Form.Item>
                        </Space>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item required={pointOrPriceWeekDay == "POINTS"} hidden={pointOrPriceWeekDay == "PRICE"} label={t("Charge Point Number 1")} name="PointNumberOfCharging1WeekDay" rules={[{required: pointOrPriceWeekDay=="POINTS"}]}>
                        <Select options={pointOpts}/>
                    </Form.Item>
                    <Form.Item required={pointOrPriceWeekDay == "PRICE"} hidden={pointOrPriceWeekDay == "POINTS"} label={t("Charge Price 1 (Pences/kWh)")} name="PriceOfCharging1WeekDay" rules={[{required: pointOrPriceWeekDay=="PRICE"}]}>
                        <InputNumber min={0} precision={3}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item required={weekEndException && pointOrPriceWeekEnd == "POINTS"} hidden={!weekEndException || pointOrPriceWeekEnd == "PRICE"} label={t("Charge Point Number 1")} name="PointNumberOfCharging1WeekEnd" rules={[{required: weekEndException && pointOrPriceWeekEnd=="POINTS"}]}>
                        <Select options={pointOpts}/>
                    </Form.Item>
                    <Form.Item required={weekEndException && pointOrPriceWeekEnd == "PRICE"} hidden={!weekEndException || pointOrPriceWeekEnd == "POINTS"} label={t("Charge Price 1 (Pences/kWh)")} name="PriceOfCharging1WeekEnd" rules={[{required: weekEndException && pointOrPriceWeekEnd=="PRICE"}]}>
                        <InputNumber min={0} precision={3}/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item required={true} label={t("Discharge Time Range 1")} name="STimeOfDischarging1WeekDay" rules={[{required: true}]} style={{ marginBottom: 0 }} >
                        <Space>
                            <Form.Item required={true} name="STimeOfDischarging1WeekDay" rules={[{required: true, message: t("required")}]}>
                                <Select style={{width: 90}} options={timeOpts}/>
                            </Form.Item>
                            <Form.Item>-</Form.Item>
                            <Form.Item required={true} name="ETimeOfDischarging1WeekDay" rules={[{required: true, message: t("required")}]}>
                                <Select style={{width: 90}} options={timeOpts}/>
                            </Form.Item>
                        </Space>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item hidden={!weekEndException} label={t("Discharge Time Range 1")}  style={{ marginBottom: 0 }}>
                        <Space>
                            <Form.Item required={weekEndException} name="STimeOfDischarging1WeekEnd" rules={[{required: weekEndException, message: t("required")}]}>
                                <Select style={{width: 90}} options={timeOpts}/>
                            </Form.Item>
                            <Form.Item>-</Form.Item>
                            <Form.Item required={weekEndException} name="ETimeOfDischarging1WeekEnd" rules={[{required: weekEndException, message: t("required")}]}>
                                <Select style={{width: 90}} options={timeOpts}/>
                            </Form.Item>
                        </Space>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item required={pointOrPriceWeekDay == "POINTS"} hidden={pointOrPriceWeekDay == "PRICE"} label={t("Discharge Point Number 1")} name="PointNumberOfDischarging1WeekDay" rules={[{required: pointOrPriceWeekDay=="POINTS"}]}>
                        <Select options={pointOpts}/>
                    </Form.Item>
                    <Form.Item required={pointOrPriceWeekDay == "PRICE"} hidden={pointOrPriceWeekDay == "POINTS"} label={t("Discharge Price 1 (Pences/kWh)")} name="PriceOfDischarging1WeekDay" rules={[{required: pointOrPriceWeekDay=="PRICE"}]}>
                        <InputNumber min={0} precision={3}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item required={weekEndException && pointOrPriceWeekEnd == "POINTS"} hidden={!weekEndException || pointOrPriceWeekEnd == "PRICE"} label={t("Discharge Point Number 1")} name="PointNumberOfDischarging1WeekEnd" rules={[{required: weekEndException && pointOrPriceWeekEnd=="POINTS"}]}>
                        <Select options={pointOpts}/>
                    </Form.Item>
                    <Form.Item required={weekEndException && pointOrPriceWeekEnd == "PRICE"} hidden={!weekEndException || pointOrPriceWeekEnd == "POINTS"} label={t("Discharge Price 1 (Pences/kWh)")} name="PriceOfDischarging1WeekEnd" rules={[{required: weekEndException && pointOrPriceWeekEnd=="PRICE"}]}>
                        <InputNumber min={0} precision={3}/>
                    </Form.Item>
                </Col>
            </Row>
            {/* 2  */}
            <Row>
                <Col span={12} style={{fontWeight: "bold", textAlign: "center", paddingBottom: 10}}>{t("Weekdays Time Setting 2")}</Col>
                <Col hidden={!weekEndException} span={12} style={{fontWeight: "bold", textAlign: "center", paddingBottom: 10}}>{t("Weekends Time Setting 2")}</Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item label={t("Charge Time Range 2")} style={{ marginBottom: 0 }} >
                        <Space>
                            <Form.Item required={true} name="STimeOfCharging2WeekDay" rules={[{required: true, message: t("required")}]}>
                                <Select style={{width: 90}} options={timeOpts}/>
                            </Form.Item>
                            <Form.Item>-</Form.Item>
                            <Form.Item required={true} name="ETimeOfCharging2WeekDay" rules={[{required: true, message: t("required")}]}>
                                <Select style={{width: 90}} options={timeOpts}/>
                            </Form.Item>
                        </Space>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item hidden={!weekEndException} label={t("Charge Time Range 2")}  style={{ marginBottom: 0 }}>
                        <Space>
                            <Form.Item required={weekEndException} name="STimeOfCharging2WeekEnd" rules={[{required: weekEndException, message: t("required")}]}>
                                <Select style={{width: 90}} options={timeOpts}/>
                            </Form.Item>
                            <Form.Item>-</Form.Item>
                            <Form.Item required={weekEndException} name="ETimeOfCharging2WeekEnd" rules={[{required: weekEndException, message: t("required")}]}>
                                <Select style={{width: 90}} options={timeOpts}/>
                            </Form.Item>
                        </Space>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item required={pointOrPriceWeekDay == "POINTS"} hidden={pointOrPriceWeekDay == "PRICE"} label={t("Charge Point Number 2")} name="PointNumberOfCharging2WeekDay" rules={[{required: pointOrPriceWeekDay=="POINTS"}]}>
                        <Select options={pointOpts}/>
                    </Form.Item>
                    <Form.Item required={pointOrPriceWeekDay == "PRICE"} hidden={pointOrPriceWeekDay == "POINTS"} label={t("Charge Price 2 (Pences/kWh)")} name="PriceOfCharging2WeekDay" rules={[{required: pointOrPriceWeekDay=="PRICE"}]}>
                        <InputNumber min={0} precision={3}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item required={weekEndException && pointOrPriceWeekEnd == "POINTS"} hidden={!weekEndException || pointOrPriceWeekEnd == "PRICE"} label={t("Charge Point Number 2")} name="PointNumberOfCharging2WeekEnd" rules={[{required: weekEndException && pointOrPriceWeekEnd=="POINTS"}]}>
                        <Select options={pointOpts}/>
                    </Form.Item>
                    <Form.Item required={weekEndException && pointOrPriceWeekEnd == "PRICE"} hidden={!weekEndException || pointOrPriceWeekEnd == "POINTS"} label={t("Charge Price 2 (Pences/kWh)")} name="PriceOfCharging2WeekEnd" rules={[{required: weekEndException && pointOrPriceWeekEnd=="PRICE"}]}>
                        <InputNumber min={0} precision={3}/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item required={true} label={t("Discharge Time Range 2")} name="STimeOfDischarging2WeekDay" rules={[{required: true}]} style={{ marginBottom: 0 }} >
                        <Space>
                            <Form.Item name="STimeOfDischarging2WeekDay">
                                <Select style={{width: 90}} options={timeOpts}/>
                            </Form.Item>
                            <Form.Item>-</Form.Item>
                            <Form.Item name="ETimeOfDischarging2WeekDay">
                                <Select style={{width: 90}} options={timeOpts}/>
                            </Form.Item>
                        </Space>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item hidden={!weekEndException} label={t("Discharge Time Range 2")}  style={{ marginBottom: 0 }}>
                        <Space>
                            <Form.Item required={weekEndException} name="STimeOfDischarging2WeekEnd" rules={[{required: weekEndException, message: t("required")}]}>
                                <Select style={{width: 90}} options={timeOpts}/>
                            </Form.Item>
                            <Form.Item>-</Form.Item>
                            <Form.Item required={weekEndException} name="ETimeOfDischarging2WeekEnd" rules={[{required: weekEndException, message: t("required")}]}>
                                <Select style={{width: 90}} options={timeOpts}/>
                            </Form.Item>
                        </Space>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item required={pointOrPriceWeekDay == "POINTS"} hidden={pointOrPriceWeekDay == "PRICE"} label={t("Discharge Point Number 2")} name="PointNumberOfDischarging2WeekDay" rules={[{required: pointOrPriceWeekDay=="POINTS"}]}>
                        <Select options={pointOpts}/>
                    </Form.Item>
                    <Form.Item required={pointOrPriceWeekDay == "PRICE"} hidden={pointOrPriceWeekDay == "POINTS"} label={t("Discharge Price 2 (Pences/kWh)")} name="PriceOfDischarging2WeekDay" rules={[{required: pointOrPriceWeekDay=="PRICE"}]}>
                        <InputNumber min={0} precision={3}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item required={weekEndException && pointOrPriceWeekEnd == "POINTS"} hidden={!weekEndException || pointOrPriceWeekEnd == "PRICE"} label={t("Discharge Point Number 2")} name="PointNumberOfDischarging2WeekEnd" rules={[{required: weekEndException && pointOrPriceWeekEnd=="POINTS"}]}>
                        <Select options={pointOpts}/>
                    </Form.Item>
                    <Form.Item required={weekEndException && pointOrPriceWeekEnd == "PRICE"} hidden={!weekEndException || pointOrPriceWeekEnd == "POINTS"} label={t("Discharge Price 2 (Pences/kWh)")} name="PriceOfDischarging2WeekEnd" rules={[{required: weekEndException && pointOrPriceWeekEnd=="PRICE"}]}>
                        <InputNumber min={0} precision={3}/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    
                </Col>
                <Col span={12}>
                    
                </Col>
            </Row>
        </Form>
    </Modal>
}

export default InverterWithAgilePriceAddOrModify;
